import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Services from './components/Services';
import Metrics from './components/Metrics';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const handleContactClick = (e) => {
    e.preventDefault();
    const email = 'info@quantena.tech';
    const subject = 'Contact from Website';
    const body = 'Hello Quantena,';

    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
      '_blank'
    );

    navigator.clipboard.writeText(email).then(() => {
      alert(`Email address ${email} copied to clipboard. Please use this to contact us if your email client didn't open.`);
    }).catch(() => {
      alert(`Please email us at ${email}`);
    });
  };

  return (
    <div className="App">
      <Header onContactClick={handleContactClick} />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Metrics />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
